//  Libraries
import React from 'react';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';
import config from 'config';

export class ShowAddOrganizerLogo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showChannelLogoTooltip: false
        };
    }

    staticChannelLogoMouseOver() {
        this.setState({showChannelLogoTooltip: true});
    }

    render() {
        return (
            <div className="channelLogo clickable">
                <div onMouseEnter={this.staticChannelLogoMouseOver.bind(this)}>
                    <img
                      src={`${config.assets.url}/images/catalog/image-full-icon.png`}
                      alt="Channel Logo Placeholder"
                      className="channelNoLogoImage"
                      onClick={this.props.onClick}
                    />
                </div>
            </div>
        );
    }
}

ShowAddOrganizerLogo.propTypes = {
    onClick: PropTypes.func,
    okBtn: PropTypes.func,
    description: PropTypes.string,
    ok: PropTypes.string
};

export default translate(['translation'])(ShowAddOrganizerLogo);




// WEBPACK FOOTER //
// ./src/components/SharedComponents/logo/ShowAddOrganizerLogo.js